import { Crisp } from 'crisp-sdk-web';
import { useEffect } from 'react';

function crispChatInit() {
  Crisp.configure("5f897bec-9596-404e-877f-03817a2c0804");
}

export default crispChatInit;